<div class="mx-auto w-full h-full justify-center space-y-6 sm:w-96">
  @if (signUpState() !== signUpEnum.SUCCESS) {
    <div class="space-y-2 text-center">
      <h1 class="text-2xl font-semibold tracking-tight">Crea un account</h1>
      <p class="text-muted-foreground text-sm">
        Inserisci i tuoi dati per registrarti
      </p>
    </div>
    <div class="grid gap-6">
      <form [formGroup]="form" (ngSubmit)="signUp()">
        <label hlmLabel>
          Email
          <input
            hlmInput
            class="w-full"
            type="email"
            id="email"
            formControlName="email"
            placeholder="nome@esempio.com"
            autocomplete="off"
          />
        </label>

        <label hlmLabel>
          Password
          <app-password-input
            class="w-full"
            formControlName="password"
            placeholder="Crea una password"
          />
        </label>

        <p class="text-destructive text-sm">
          @if (signUpState() === signUpEnum.FAIL) {
            Errore durante la registrazione
          }
        </p>

        <button hlmBtn [disabled]="isLoading()" class="mt-2 w-full">
          @if (isLoading()) {
            <hlm-spinner size="sm" class="mr-2" />
          }
          Registrati
        </button>

        <div class="px-4 py-2 text-center">
          <span class="text-muted-foreground text-sm">
            Hai già un account?
          </span>

          <button
            hlmBtn
            variant="link"
            [disabled]="isLoading()"
            (click)="onSignInClick()"
            type="button"
          >
            Accedi
          </button>
        </div>
      </form>
    </div>
  } @else {
    <div class="space-y-2 text-center">
      <h1 class="text-2xl font-semibold tracking-tight">
        Registrazione completata
      </h1>
      <p class="text-muted-foreground text-sm">
        <span> Il tuo account è stato creato con successo. </span>
        <button
          hlmBtn
          variant="link"
          [disabled]="isLoading()"
          (click)="onSignInClick()"
          type="button"
        >
          Accedi
        </button>
      </p>
    </div>
  }
</div>
